import { UserType } from "@fronterahealth/frontera-ui-components";

import {
  CreateRecommendationBankItemInput,
  ReportSectionFieldsType,
  useCreateRecommendationBankItemMutation,
  useGetRecommendationBankItemsQuery,
} from "@api/graphql/types-and-hooks";
import { getFolderSelections } from "@components/GoalsBank/utils";
import { useRecommendationsBankFolders } from "@components/RecommendationsBank/hooks/useRecommendationsBankFolders";
import { getOrgFolderSection, getUserFolderSection } from "@components/RecommendationsBank/utils";
import { useFormUtils } from "@components/forms/useFormUtils";
import { notifySuccess } from "@components/notifications/notifications";
import { useAdminData } from "@providers/AdminDataProvider";

// Encapsulates the "save recommendation to a folder" flow (folder lookup, the
// create mutation and the select form) so the dropdown can offer it without the
// Evaluation recommendations page threading a callback down.
export const useSaveToFolder = (field: ReportSectionFieldsType, onSaved: () => void) => {
  const { orgnizationDetailsQuery } = useAdminData();
  const recommendationBankQuery = useGetRecommendationBankItemsQuery({}, {});
  const { userFolders, orgFolders, createNewFolder } = useRecommendationsBankFolders();
  const createRecommendation = useCreateRecommendationBankItemMutation({
    onSuccess: async () => {
      notifySuccess("Successfully saved Recommendation to folder");
      recommendationBankQuery?.refetch();
      reset();
      onSaved();
    },
    onError: async (error: unknown) => {
      console.error("Error when saving Recommendation to folder", error);
    },
  });

  const { data } = orgnizationDetailsQuery;
  const userType: UserType = data?.getUserOrgnizationDetails?.id ? "organization" : "selfServe";
  const userFoldersSection = getUserFolderSection(userFolders);
  const orgFoldersSection = getOrgFolderSection(orgFolders, data?.getUserOrgnizationDetails?.name ?? "");

  const { formState, RegisteredFormSelected, reset, onSubmit } = useFormUtils<CreateRecommendationBankItemInput>({
    mutationFn: async (params) => {
      if (!params.folderId) return;
      await createRecommendation.mutateAsync({
        input: {
          recommendationContent: field.content ?? "",
          recommendationTitle: field.title,
          folderId: params.folderId,
        },
      });
    },
  });

  return {
    userType,
    createNewFolder,
    formState,
    RegisteredFormSelected,
    reset,
    onSubmit,
    folderSelections: getFolderSelections(userFoldersSection, orgFoldersSection),
  };
};
